/**
 * @file dataUploadContstant.js
 * @description Constants for the Data Upload module.
 *              Includes UI label strings, table configurations, messages, and error constants.
 *
 * @module dataUploadContstant
 *
 * @exports DATA_UPLOAD_ERRORS    - Error message strings for data upload operations.
 * @exports DATA_UPLOAD_SUCCESS   - Success message strings for data upload operations.
 * @exports DATA_UPLOAD_STRINGS   - UI label strings for the data upload panel.
 */

export const DATA_UPLOAD_ERRORS = {
    UPLOAD_CSV_ERROR: "Error uploading CSV file:",
    SAVE_UPLOAD_ERROR: "Error saving upload data:",
}

export const DATA_UPLOAD_SUCCESS = {
    SAVE_UPLOAD_SUCCESS: "Data upload saved successfully.",
}


export const DATA_UPLOAD_STRINGS = {
   SAVE_DATABASE: "Save to Database",
   ERROR_FOUND: "Errors Found:",
   DOWNLOAD_CSV: "Download CSV"
}


 